import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import {
  calculatePeriodValueBaseOnPreviousPeriod,
  PERIODS_OPERATION_TYPES,
  summarizeSubtractPeriodValues,
} from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetCommonStockCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [commonStockFiled] = observedFields.commonStock.setCalculatedValueFieldNames;

  const getCommonStockCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const [initialEquity, proceedsEquity, financialActivitiesTable] = content;
        const calculatedEquity = summarizeSubtractPeriodValues(
          [proceedsEquity, financialActivitiesTable[0]],
          PERIODS_OPERATION_TYPES.ADD,
        );
        const longTermDebt = calculatePeriodValueBaseOnPreviousPeriod(calculatedEquity, initialEquity);

        setValue(commonStockFiled, longTermDebt);
      }, 500),
     
    [],
  );

  return getCommonStockCalculationHandler;
};
